import * as React from 'react';
import styles from './index.less';
import img_zip from '@/assets/zip.png';
import img_txt from '@/assets/txt.png';
import img_audio from '@/assets/audio.png';
import img_pdf from '@/assets/pdf.png';
import img_cartoon from '@/assets/cartoon.png';
import img_general from '@/assets/general.png';
import img_video from '@/assets/video.png';
import img_image from '@/assets/image.png';
import { FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';
import { CoverGenerator } from '@/utils/CoverGenerator';
import FIcons from '../FIcons';

interface FFileIconProps {
  mime: string;
  sha1: string;
}

function FFileIcon({ mime, sha1 }: FFileIconProps) {
  const ref_Abort = React.useRef<any>(null);

  const [$url, set$url, get$url] = FUtil.Hook.useGetState<string>('');

  AHooks.useDebounceEffect(
    () => {
      if (sha1) {
        // debugger;
        try {
          ref_Abort.current?.();
        } catch (e) {}

        ref_Abort.current = CoverGenerator.generateCover(
          [sha1],
          (data) => {
            set$url(data.url);
          },
          () => {},
        );
      } else {
        set$url('');
      }
    },
    [sha1],
    {
      wait: 100,
    },
  );

  AHooks.useUnmount(() => {
    try {
      ref_Abort.current?.();
    } catch (e) {}
  });

  if ($url) {
    return <img src={$url} alt={''} />;
  }

  if (mime?.startsWith('image/')) {
    return sha1 ? (
      <div className={styles.placeholder1}>
        <FIcons.FLoading style={{ fontSize: 20, color: '#999' }} />
      </div>
    ) : (
      <img src={img_image} alt={''} style={{ width: 50 }} />
    );
  }

  if (mime?.startsWith('video/')) {
    return sha1 ? (
      <div className={styles.placeholder1}>
        <FIcons.FLoading style={{ fontSize: 20, color: '#999' }} />
      </div>
    ) : (
      <img src={img_video} alt={''} style={{ width: 50 }} />
    );
  }

  if (mime?.startsWith('text/')) {
    return <img src={img_txt} alt={''} style={{ width: 50 }} />;
  }

  if (mime?.startsWith('audio/')) {
    return <img src={img_audio} alt={''} style={{ width: 50 }} />;
  }

  // if (mime?.startsWith('video/')) {
  //   return (
  //     <>
  //       <video src={url} style={{ width: '100%', maxHeight: '100%' }} />
  //       <div
  //         style={{
  //           position: 'absolute',
  //           top: 0,
  //           right: 0,
  //           bottom: 0,
  //           left: 0,
  //           width: '100%',
  //           height: '100%',
  //           backgroundColor: 'rgba(0,0,0,.3)',
  //           display: 'flex',
  //           alignItems: 'center',
  //           justifyContent: 'center',
  //         }}
  //       >
  //         <i
  //           className={['freelog', 'fl-icon-bofang-daibiankuang'].join(' ')}
  //           style={{ fontSize: 36, color: 'white' }}
  //         />
  //       </div>
  //     </>
  //   );
  // }

  // if (mime?.startsWith('image/')) {
  //   return <img src={url} alt={''} style={{ width: '100%', maxHeight: '100%' }} />;
  // }

  if (
    [
      'application/gzip',
      'application/x-gzip',
      'application/zip',
      'application/rar',
      'application/vnd.rar',
      'application/tar',
      'application/x-tar',
    ].includes(mime)
  ) {
    return <img src={img_zip} alt={''} style={{ width: 50 }} />;
  }

  if (mime?.startsWith('application/pdf')) {
    return <img src={img_pdf} alt={''} style={{ width: 50 }} />;
  }

  if (mime === 'application/vnd.freelog.comic') {
    return <img src={img_cartoon} alt={''} style={{ width: 50 }} />;
  }

  return <img src={img_general} alt={''} style={{ width: 50 }} />;
}

export default FFileIcon;
